module.exports = [require("./Header"), require("./Paragraph")];
